import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {LoggingService} from 'mclane-apptemplate-lib';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  static readonly DATE_FORMATS = {
    parse: {
      dateInput: 'MM/DD/YYYY'
    },
    display: {
      dateInput: 'MM/DD/YYYY',
      monthYearLabel: 'MMM YYYY'
    },
    useUtc: true
  };

  readonly BASEURL = window.location.protocol + '//' + window.location.host;
  //readonly RESTPATH = '/fs-online-invoicing-ws/rest/v1';
  //readonly RESTURL = this.BASEURL + this.RESTPATH;
  readonly RESTURL = environment.servicePrefix;
  readonly RESTURL_CONNECT_SUPPORT = environment.supportServicePrefix;
  //readonly RESTURL = 'http://localhost:9080' + this.RESTPATH;

  private _isLogoutCalled = false;


  constructor(public console: LoggingService) {
    this.console.log('this.BASEURL=' + environment.servicePrefix);
    this.console.log('this.LOGGING.BASEURL=' + environment.supportServicePrefix);
  }

  get isLogoutCalled() {
    return this._isLogoutCalled;
  }

  set isLogoutCalled(value: boolean) {
    this._isLogoutCalled = value;
  }
}
